<template>
    <div class="pt-4 pl-2 pr-2 pb-4 bg-white bin-details-overview" :class="{ 'd-none': entitlmentTableHistoryEmpty && binCollectionScheduleEmpty }">        
        <entitlement-table-history :custom-table-header-color-style="customHeaderColor" customClass="" v-if="isAddressSelected" :addressId="isAddressSelected" ref="entitlmentTableHistoryRef" @dataCountRetrieved="entitlmentTableHistoryData"  />
        <bin-collection-schedule :custom-table-header-color-style="customHeaderColor" customClass="" v-if="isAddressSelected" :addressId="isAddressSelected" ref="binCollectionScheduleRef" @dataCountRetrieved="binCollectionScheduleData" />
    </div>
</template>

<script>
    import EntitlementTableHistory from './EntitlementTableHistory';
    import BinCollectionSchedule from "../../../../common/components/BinCollectionSchedule";

    export default {
        components: {
            EntitlementTableHistory,
            BinCollectionSchedule
        },
        data() {
            return {
                entitlmentTableHistoryEmpty: false,
                binCollectionScheduleEmpty: false
            }
        },
        mounted(){
        },
        computed: {
            isAddressSelected() {
                return (this.$store.getters['GET_ACTIVE_ADDRESS'] && Number(this.$store.getters['GET_ACTIVE_ADDRESS'].id)) || false;
            },
            customHeaderColor() {
                const { button_color, button_text_color } = this.$store.getters['GET_MAIN_UI'];
                return (this.$store.getters.GET_PERSONAL_INFO.type === 'cso' && `background-color:${button_color};color:${button_text_color}`) || '';
            }
        },
        watch: {
            isAddressSelected: function(addressId) {
                if (addressId) {
                    this.$refs.entitlmentTableHistoryRef.loading = true;
                    this.$refs.entitlmentTableHistoryRef.onload();

                    this.$refs.binCollectionScheduleRef.loading = true;
                    this.$refs.binCollectionScheduleRef.loadScheduleTypes();
                }
            }
        },
        methods: {
            entitlmentTableHistoryData(length) {
                this.entitlmentTableHistoryEmpty = length < 1;
            },
            binCollectionScheduleData(length) {
                this.binCollectionScheduleEmpty = length < 1;
            }
        }
    }
</script>